<template>
  <nav :class="['fab', { 'active': isActive }]">
    <slot>
      <a href="#" class="fab-link" v-for="link in linkList" :key="link.id" :tooltip="link.tooltip" @click.prevent="emit(link.callback)">
        <img v-if="link.src" :src="link.src" class="fab-icon">
      </a>
      <a href="#" class="fab-toggle" @click.prevent="isActive = !isActive" data-toggle="true">
        <div class="fab-toggle-icon" data-toggle="true"></div>
      </a>
    </slot>
  </nav>
</template>

<script>
  export default {
    name: 'fab',
    props: {
      linkList: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data () {
      return {
        isActive: false
      }
    },
    methods: {
      close (event) {
        // FAB 활성화 상태에서 토글 버튼을 제외한 클릭 이벤트 발생 시 비활성화 상태로 변경
        if (this.isActive) {
          const isToggle = event.target.getAttribute('data-toggle')
          if (!isToggle) {
            this.isActive = false
          }
        }
      },
      emit (cb) {
        if (this.isActive) {
          this.$emit(cb)
        }
      }
    },
    mounted () {
      document.addEventListener('click', this.close)
    },
    beforeDestroy () {
      document.removeEventListener('click', this.close)
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/components/fab';
</style>



// WEBPACK FOOTER //
// src/components/admin/Fab.vue